import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
  DialogActions,
  DialogContentText,
  Button,
} from '@mui/material';
import { useLocalization } from '@/hooks/useLocalization';
import { useNavigate } from 'react-router';
import Close from '@mui/icons-material/Close';
import { paths } from '@/constants/paths';

interface ManageAccountPermissionsModalProps {
  open: boolean;
  onClose: () => void;
  destination?: string;
}

export const ManageAccountPermissionsModal = ({
  open,
  onClose,
  destination = paths.investor.team,
}: ManageAccountPermissionsModalProps) => {
  const { t } = useLocalization();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const handleSetPermissions = () => {
    void navigate(destination, {
      state: { scrollToTop: true },
    });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='xs'
      fullScreen={isMobile}
      disableRestoreFocus
      sx={(theme) => ({
        [theme.breakpoints.down('sm')]: {
          '& .MuiPaper-root': {
            paddingTop:
              'var(--safe-area-inset-top, env(safe-area-inset-top, 0px))',
            paddingBottom:
              'var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))',
          },
        },
      })}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          component='span'
          variant='h6'
        >
          {t('setAccountPermissions')}
        </Typography>

        <IconButton
          aria-label={t('close')}
          onClick={onClose}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {t('accountPermissionsModalDescription')}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          size='large'
          variant='outlined'
          onClick={onClose}
        >
          {t('cancel')}
        </Button>

        <Button
          size='large'
          variant='contained'
          onClick={handleSetPermissions}
        >
          {t('ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManageAccountPermissionsModal;
